import { render, staticRenderFns } from "./RegisterBookCreate.vue?vue&type=template&id=5ae6cfcf&"
import script from "./RegisterBookCreate.vue?vue&type=script&lang=js&"
export * from "./RegisterBookCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports